import React from 'react';
import {Grid} from '@material-ui/core'
import {delivery, secure, starFill, thumb,} from '../../../assets/images/images'


const data = [
  {
    id: 1,
    icon: delivery,
    value: 'Connecting smallholder farmers directly to fair, verified buyers across the country to trade products and services.',
    title: 'Global Marketplace'
  },
  {
    id: 1,
    icon: secure,
    value: 'Simple, secure online payments for every verified transaction.',
    title: 'Secure Payment'
  },
  {
    id: 1,
    icon: thumb,
    value: 'Product certificates, Nutrition values, Product lifecycle and chronological information.',
    title: 'Best Quality'
  },
  {
    id: 1,
    icon: starFill,
    value: 'List your harvest and services to reach verified buyers across the country, no middlemen required.',
    title: 'Market Access'
  },
  {
    id: 1,
    icon: starFill,
    value: 'Alarms alerts guidelines, best practices, nearest market alerts and weather information',
    title: 'AI engine'
  },
  {
    id: 1,
    icon: secure,
    value: 'Traceable products with nutrition details, quality checks, approvals and transparent negotiations.',
    title: 'Traceability'
  },
  {
    id: 1,
    icon: delivery,
    value: 'A dashboard with Sales graph, negotiations , guidelines, reminders and Alerts.',
    title: 'productivity'
  },
  {
    id: 1,
    icon: secure,
    value: 'Manufacturer/Vendors, Growers, Service provider, Food producer, Food Markets ,and Governments.',
    title: 'Beneficiary'
  },
]

function Index(props) {
  return (
    <Grid container style={{backgroundColor: '#FFF', padding: 20, marginTop: 20}} justify={'center'}>
      {/*<Grid className='display-flex'>*/}
      {data.map((item, index) => {
        return (
          <Grid xs={6} md={3} direction='column' container alignItems={'center'} className='p-10'>
            <img src={item.icon} alt='' className='discount-color p-10 light-background border-radius-10'/>
            <h3 className='heading-color m-0 font-20 text-capitalize'> {item.title}</h3>
            <p className='in-active-color basic-font text-center font-12 max-width-80'>{item.value}</p>
          </Grid>
        )
      })}
      {/*</Grid>*/}
    </Grid>

  );
}

export default Index;

